module.exports = __webpack_public_path__ + "static/media/tasklevel2_open.ca275cdd.png";